export const SENTRY_RELEASE: string | undefined = 'f2be0e9b2a7fedf46530c67d4a80b711aaccfb79';
